import { Space } from 'antd'
import KButton from 'app/components/Modules/General/KButton'
import { RecordType } from 'app/constants/GlobalTypes'
import { Routes } from 'app/routes/Routes'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { MemberProps } from '../../convention'

type Props = {
  loading?: boolean
  disabledSubmit?: boolean
  onCancel?: () => void
  onSubmit?: () => void
  complaintActive?: boolean
  setComplaintActive?: (value: boolean) => void
}

export type ComplainPayload = {
  description: string
  reason?: string
}

const Footer: React.FC<MemberProps<IInvoice, Props>> = ({
  props: { onCancel, onSubmit, loading, disabledSubmit, complaintActive, setComplaintActive },
  member
}) => {
  const navigate = useNavigate()
  const goToRental = () => navigate(Routes.Rental.member(`${member.rental_id}`).show)
  const goToProject = () => navigate(Routes.Project.member(`${member.project_id}`).invoice)
  const goToDamageInfo = () => navigate(Routes.Rental.member(`${member.rental_id}`).damage)

  return (
    <Space>
      {member?.damage_invoice && (
        <KButton
          recordType={RecordType.damage_info}
          action="link"
          type="secondary"
          onClick={goToDamageInfo}
        />
      )}
      <KButton recordType={RecordType.rental} action="link" type="secondary" onClick={goToRental} />
      <KButton
        recordType={RecordType.project}
        action="link"
        type="secondary"
        onClick={goToProject}
      />
      <Choose>
        <When condition={complaintActive}>
          <KButton
            type="secondary"
            recordType={RecordType.invoice}
            action="cancel"
            onClick={() => setComplaintActive(false)}
          />
          <KButton
            type="primary"
            recordType={RecordType.invoice}
            action="complain"
            onClick={onSubmit}
            loading={loading}
            disabled={disabledSubmit}
          />
        </When>
        <Otherwise>
          <KButton
            recordType={RecordType.invoice}
            action="complain"
            type="secondary"
            onClick={() => setComplaintActive(true)}
          />
          <KButton
            type="primary"
            recordType={RecordType.invoice}
            action="cancel_invoice"
            onClick={onCancel}
          />
        </Otherwise>
      </Choose>
    </Space>
  )
}

export default Footer
